import React from 'react';
import { Routes, Route } from 'react-router-dom';
import TagsPage from '@pages/tags/TagsPage';
import TagViewPage from '@pages/tags/TagViewPage';
import TagEditPage from '@pages/tags/TagEditPage';
import TagCreatePage from '@pages/tags/TagCreatePage';

export const TagsRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<TagsPage />} />
            <Route path="/create" element={<TagCreatePage />} />
            <Route path="/:id" element={<TagViewPage />} />
            <Route path="/:id/edit" element={<TagEditPage />} />
        </Routes>
    );
};

export default TagsRoutes;
